<template>
  <b-modal id="subscription-upgrade" size="lg" no-close-on-backdrop v-if="plans">
    <template #modal-header>
      Upgrade Your Account
    </template>

    <div class="d-block text-center">
      <b-form-group label-for="plan">
        <b-form-select v-model="plan" :options="mappedOptions"></b-form-select>
      </b-form-group>

      <div v-if="plan == plans[1].monthly_price.id">
        <b-card header="Lead Others Monthly" header-tag="header" footer-tag="footer">
          <b-card-text>
            <b-list-group>
              <b-list-group-item>{{ plans[1].monthly_price.price / 100 | currency }} / Month</b-list-group-item>
              <b-list-group-item>2-4 Agent</b-list-group-item>
              <b-list-group-item>Admins FREE</b-list-group-item>
            </b-list-group>
          </b-card-text>
        </b-card>
      </div>
      <div v-if="plan == plans[1].yearly_price.id">
        <b-card header="Lead Others Yearly" header-tag="header" footer-tag="footer">
          <b-card-text>
            <b-list-group>
              <b-list-group-item>{{ plans[1].yearly_price.price / 100 | currency }} / Year</b-list-group-item>
              <b-list-group-item>2-4 Agent</b-list-group-item>
              <b-list-group-item>Admins FREE</b-list-group-item>
            </b-list-group>
          </b-card-text>
        </b-card>
      </div>
      <div v-if="plan == plans[2].monthly_price.id">
        <b-card header="Create Leaders Monthly" header-tag="header" footer-tag="footer">
          <b-card-text>
            <b-list-group>
              <b-list-group-item>{{ plans[2].monthly_price.price / 100 | currency }} / Month</b-list-group-item>
              <b-list-group-item>5+ Agents</b-list-group-item>
              <b-list-group-item>Admins FREE</b-list-group-item>
            </b-list-group>
          </b-card-text>
        </b-card>
      </div>
      <div v-if="plan == plans[2].yearly_price.id">
        <b-card header="Create Leaders Yearly" header-tag="header" footer-tag="footer">
          <b-card-text>
            <b-list-group>
              <b-list-group-item>{{ plans[2].yearly_price.price / 100 | currency }} / Year</b-list-group-item>
              <b-list-group-item>5+ Agents</b-list-group-item>
              <b-list-group-item>Admins FREE</b-list-group-item>
            </b-list-group>
          </b-card-text>
        </b-card>
      </div>
    </div>

    <template #modal-footer>
      <b-button size="sm" variant="danger" @click="cancel">Cancel</b-button>
      <b-button size="sm" variant="success" @click="submit" :disabled="plan == null">Upgrade</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    plans: [],
  },
  data: function() {
    return {
      plan: null
    }
  },
  computed: {
    mappedOptions() {
      const options = [];
      if(this.plans) {
        this.plans.forEach(function(plan) {
          if(plan.name !== 'Leading Yourself') {
            options.push({
              text: plan.name + ' Monthly',
              value: plan.monthly_price.id
            });

            options.push({
              text: plan.name + ' Yearly',
              value: plan.yearly_price.id
            });
          }
        });
      }

      return options;
    }
  },
  methods: {
    submit() {
      this.$emit('upgrade', this.plan);
    },
    cancel() {
      this.plan = null;
      this.$bvModal.hide('subscription-upgrade');
    }
  }
};
</script>